import { dictionary } from "skin/event";
import { status } from "skin/event/status";

const typeValueDictionary = (data, type, info) =>
	dictionary({
		info,
		code: type === "exGroup" ? "productExceptGroup" : "bool",
		func: (value) => {
			data.setValue("valueTxt", type === "exGroup" ? value[0] : value);
			data.setValue("value", type === "exGroup" ? value[1] : value);
		},
	});

const typeChangeFx = (data) => {
	data.setValue("valueTxt", "");
	data.setValue("value", "");
	return status.action;
};

const valueTxtChangeFx = (data, obj, type) => {
	if (type !== "min" && type !== "limit") return status.ignore;
	data.setValue("value", obj.value);
	return status.action;
};

const setInputFx = (data, obj, type) => {
	if (obj.name === "type") return typeChangeFx(data);
	if (obj.name === "valueTxt") return valueTxtChangeFx(data, obj, type);
	return status.action;
};

const dictionaryFx = (data, obj, type) => {
	if (obj.code === "promoConditionType") return status.action;
	if (type && type !== "min" && type !== "limit")
		typeValueDictionary(data, type, [data.curData.values.fld.promoId]);
	return status.ignore;
};

export default function msPromoCondition(obj, ms, story, data, d, action) {
	const type = data.curData.values.fld.type;

	if (obj.action === "setInput") return setInputFx(data, obj, type);
	if (obj.action === "dictionary" && obj.code !== "promoConditionType")
		return dictionaryFx(data, obj, type);
	return status.action;
}
